module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/HourlyPrecipitation30/Kanagawa_HourlyPrecipitation30_MRI_RCP85_End.png";